import React from "react";
import '../../App.css';
import Certificates from './Certificates';
import Footer from '../Footer';
// import { Container } from "react-bootstrap";
import './Achivement.css';
import { useEffect } from "react";


export default function Achivement() {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return(
        
            <div>
                <h1 className="heading">ACHIVEMENTS</h1>
                <Certificates />
            </div>
        
    );
}

